import convert from "convert-units";

const lengthUnits = convert().list("length");
const numberFormatter = new Intl.NumberFormat(undefined, {
  maximumFractionDigits: 2,
});

export function formatLengthMeasurement(
  value?: string,
  unitAbbreviation?: string,
): string {
  if (!value) return "";

  const numericValue = Number(value);
  const formattedValue = Number.isFinite(numericValue)
    ? numberFormatter.format(numericValue)
    : value;
  const unit = lengthUnits.find(
    (candidate: any) => candidate.abbr === unitAbbreviation,
  );

  if (!unit)
    return [formattedValue, unitAbbreviation].filter(Boolean).join(" ");

  const unitName = Math.abs(numericValue) === 1 ? unit.singular : unit.plural;
  return `${formattedValue} ${unitName}`;
}
